import React, { useState, useEffect } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import { Dialog, DialogActions, DialogContent, DialogTitle, TextField, Button, Checkbox, FormControlLabel,FormControl,Select,MenuItem,InputLabel } from '@mui/material';
import axiosInstance from '../AxiosInstance';
import { addWeeks } from 'date-fns';

const VenueScheduleCalendar = ({ venueId, currentVenue }) => {
    const [events, setEvents] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);
    const [newEvent, setNewEvent] = useState({
        courseTitle: '',
        start: '',
        end: '',
        repeatTimes: 0,
        price: 0
    });
    const [selectedDate, setSelectedDate] = useState('');
    const [conflictDialogOpen, setConflictDialogOpen] = useState(false);
    const [conflictDetails, setConflictDetails] = useState([]);

    useEffect(() => {
        if (venueId && currentVenue) {
            console.log('Current Venue:', currentVenue);
            fetchEvents();
        }
    }, [venueId, currentVenue]);

    const fetchEvents = async () => {
        try {
            const response = await axiosInstance.get(`/venue/schedule?venueId=${venueId}`);
            const availableTimes = response.data.data;
            console.log(response.data.data);
            // Convert the data to FullCalendar event format
            const eventsData = availableTimes.map(time => ({
                title: time.courseTitle,
                start: `${time.date}T${time.startTime}`,
                end: time.endTime ? `${time.date}T${time.endTime}` : undefined,
                price: time.price,
                backgroundColor: 'lightgreen',
                id: time.id,
                extendedProps: {
                    endTime: time.endTime, // 确保结束时间传递到extendedProps
                }
            }));

            setEvents(eventsData);
        } catch (error) {
            console.error('Error fetching events:', error);
        }
    };

    const handleDateClick = (arg) => {
        setSelectedDate(arg.dateStr);
        setOpenDialog(true);
    };

    const handleEventClick = async (clickInfo) => {
        if (window.confirm(`Are you sure you want to delete the event '${clickInfo.event.title}'`)) {
            try {
                const response = await axiosInstance.delete(`/venue/schedule`, { params: { id: clickInfo.event.id } }); // MODIFIED
                if (response?.data?.code && response.data.code !== 0) {
                    throw new Error(response.data.message || 'Delete slot failed');
                }
                clickInfo.event.remove();
                fetchEvents();
            } catch (error) {
                console.error('Error deleting event:', error);
                const backendMessage = error?.response?.data?.message || error?.message || '';
                if (backendMessage.startsWith('SLOT_CONFLICT:')) {
                    const details = backendMessage
                        .split('\n')
                        .slice(1)
                        .map((line) => line.trim())
                        .filter(Boolean);
                    setConflictDetails(details);
                    setConflictDialogOpen(true);
                }
            }
        }
    };

const saveEvent = async () => {
    if (!newEvent.courseTitle?.trim() || !newEvent.start?.trim() || !newEvent.end?.trim()) {
        return;
    }

    const eventsToSave = [];

    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    for (let i = 0; i < (newEvent.repeatTimes > 0 ? newEvent.repeatTimes : 1); i++) {
        let eventDate = new Date(selectedDate + 'T00:00:00');
        eventDate.setDate(eventDate.getDate() + (i * 7)); // 计算每周的日期

        eventsToSave.push({
            courseTitle: newEvent.courseTitle || 'unkonw',
            date: formatDate(eventDate),
            venueId: venueId,
            startTime: newEvent.start,
            endTime: newEvent.end,
            price:newEvent.price
        });
    }

        try {
            const responses = await Promise.all(eventsToSave.map(event =>
                axiosInstance.post(`/venue/schedule`, event)
            ));
            const failedResponse = responses.find((res) => res?.data?.code !== 0);
            if (failedResponse) {
                throw new Error(failedResponse?.data?.message || 'Save slot failed');
            }
            setOpenDialog(false);
            fetchEvents();
        } catch (error) {
            console.error('Error saving event:', error);
            const backendMessage = error?.response?.data?.message || error?.message || '';
            if (backendMessage.startsWith('SLOT_CONFLICT:')) {
                const details = backendMessage
                    .split('\n')
                    .slice(1)
                    .map((line) => line.trim())
                    .filter(Boolean);
                setConflictDetails(details);
                setConflictDialogOpen(true);
            } else {
                setConflictDetails([backendMessage || 'Failed to save slot.']);
                setConflictDialogOpen(true);
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value, checked, type } = e.target;
        setNewEvent(prevState => ({ ...prevState, [name]: type === 'checkbox' ? checked : value }));

        // 根据 courseTitle 更新价格
        if (name === 'courseTitle' && currentVenue) {
            console.log('Selected Course Title:', value);
            let price = 0;
            switch (value) {
                case 'cpr':
                    price = currentVenue.cprPrice;
                    break;
                case 'bls':
                    price = currentVenue.blsPrice;
                    break;
                case 'cpradult':
                    price=currentVenue.cpradultPrice;
                    break;
                case 'cprinstructor':
                    price=currentVenue.cprinstructorPrice;
                    break;
                case 'cprskill':
                    price=currentVenue.cprskillPrice;
                    break;
                case 'AHA BLS':
                    price = 0;
                    break;
                default:
                    price = 0;
                    break;
            }
            setNewEvent(prevState => ({ ...prevState, price, courseTitle: value  }));
        }
         // 当 start 时间变化时，自动设置 end 时间为 start 时间 + 2 小时
    if (name === 'start') {
        const [hours, minutes] = value.split(':'); // 分割出小时和分钟
        let newEndHour = parseInt(hours);
        let newEndMinute = parseInt(minutes);
        let additionalHours = 2;
        let additionalMinutes = 0;
    
        if (newEvent.courseTitle === 'cpr') {
            additionalMinutes = 15; 
        } else if (newEvent.courseTitle === 'bls' || newEvent.courseTitle === 'AHA BLS') {
            additionalMinutes = 30; 
        } else if (newEvent.courseTitle === 'cprskill') {
            additionalMinutes = 15;
        } else if (newEvent.courseTitle === 'cpradult') {
            additionalMinutes = -30; 
        }
    
        // 先加分钟
        newEndMinute += additionalMinutes;
    
        // 处理分钟溢出（如果超过 60）
        if (newEndMinute >= 60) {
            newEndHour += Math.floor(newEndMinute / 60);
            newEndMinute = newEndMinute % 60;
        }
    
        // 处理分钟为负数的情况
        if (newEndMinute < 0) {
            newEndHour -= 1;
            newEndMinute += 60;
        }
    
        // 加上额外的 2 小时
        newEndHour += additionalHours;
    
        // 确保小时数在 24 小时制内
        if (newEndHour >= 24) {
            newEndHour -= 24;
        } else if (newEndHour < 0) {
            newEndHour += 24;
        }
    
        const endTime = `${String(newEndHour).padStart(2, '0')}:${String(newEndMinute).padStart(2, '0')}`;

        setNewEvent(prevState => ({ ...prevState, end: endTime })); // 更新 end 时间
    }
    };

    const renderEventContent = (eventInfo) => (
        <div>
            <b>{eventInfo.timeText}</b>
            <i>{eventInfo.event.title}</i>
            <div>{eventInfo.event.extendedProps.endTime ? `End: ${eventInfo.event.extendedProps.endTime}` : ''}</div>
            <div>{eventInfo.event.extendedProps.price ? `Price: $${eventInfo.event.extendedProps.price}` : ''}</div>
        </div>
    );

    const canSave =
        Boolean(newEvent.courseTitle?.trim()) &&
        Boolean(newEvent.start?.trim()) &&
        Boolean(newEvent.end?.trim());

    return (
        <div>
            <FullCalendar
                plugins={[dayGridPlugin, interactionPlugin]}
                initialView="dayGridMonth"
                events={events}
                dateClick={handleDateClick}
                eventClick={handleEventClick}
                eventContent={renderEventContent}
            />
            <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
                <DialogTitle>Add New Event</DialogTitle>
                <DialogContent>

                <FormControl fullWidth margin="dense" required>
                    <InputLabel id="course-title-label">Course Title</InputLabel>
                    <Select
                    labelId="course-title-label"
                    name="courseTitle"
                    label="Course Title"
                    value={newEvent.courseTitle ||''}
                    onChange={handleInputChange}
                    autoFocus
                    >
                    <MenuItem value="cpr">CPR</MenuItem>
                    <MenuItem value="bls">BLS</MenuItem>
                    <MenuItem value="AHA BLS">AHA BLS</MenuItem>
                    <MenuItem value="cpradult">CPR Adult</MenuItem>
                    <MenuItem value="cprinstructor">CPR Instructor</MenuItem>
                    <MenuItem value="cprskill">CPR Skill</MenuItem>
                     </Select>
                    </FormControl>
                    <TextField
                        margin="dense"
                        name="start"
                        label="Start Time"
                        type="time"
                        fullWidth
                        required
                        InputLabelProps={{ shrink: true }}
                        value={newEvent.start}
                        onChange={handleInputChange}
                    />
                    <TextField
                        margin="dense"
                        name="end"
                        label="End Time"
                        type="time"
                        fullWidth
                        required
                        InputLabelProps={{ shrink: true }}
                        value={newEvent.end}
                        onChange={handleInputChange}
                    />
                    <TextField
                        margin='dense'
                        name="price"
                        label="Price"
                        type="number"
                        value={newEvent.price}
                        onChange={handleInputChange}
                        inputProps={{ min: 0 }} 
                      />
                    {/* <FormControlLabel
                        control={
                            <Checkbox
                                checked={newEvent.isWeekly}
                                onChange={handleInputChange}
                                name="isWeekly"
                                color="primary"
                            />
                        }
                        label="Repeat weekly for 4 weeks"
                    /> */}
                 <TextField
                        margin='dense'
                        name="repeatTimes"
                        label="Repeat times"
                        type="number"
                        value={newEvent.repeatTimes}
                        onChange={handleInputChange}
                        inputProps={{ min: 0 }} 
                      />

                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDialog(false)} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={saveEvent} color="primary" disabled={!canSave}>
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={conflictDialogOpen}
                disableEscapeKeyDown
                onClose={(event, reason) => {
                    if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
                    setConflictDialogOpen(false);
                }}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle>Slot Conflict Detected</DialogTitle>
                <DialogContent dividers>
                    {conflictDetails.length > 0 ? (
                        conflictDetails.map((detail, idx) => (
                            <div key={`${detail}-${idx}`}>{detail}</div>
                        ))
                    ) : (
                        <div>Conflicting slot found. No data was saved.</div>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => setConflictDialogOpen(false)}
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default VenueScheduleCalendar;